<template>
  <div class="modal">
    <div class="modal__backdrop" @click="$emit('on-close')"></div>
    <div class="modal__wrapper">
      <div class="modal__close">
        <button
          type="button"
          class="icon-button error"
          @click="$emit('on-close')"
        >
          <span class="material-icons">close</span>
        </button>
      </div>
      <h2 class="modal__title">{{ $t("wellb.title") }}</h2>
      <div class="modal__data">
        <div class="person">
          <span>{{ $t("wellb.preventieadviseur") }}</span>
          <span>Amine Chetti</span>
          <a class="button" target="_blank" href="tel:+32472311981"
            >+32472311981</a
          >
          <a class="button" target="_blank" href="mailto:amine@huureenstuur.be"
            >amine@huureenstuur.be</a
          >
          <span>Wiedauwkaai 98, 9000 Gent</span>
        </div>
        <div class="person">
          <span>{{ $t("wellb.vertrouwenspersoon") }}</span>
          <span>Kate Debackere</span>
          <a class="button" target="_blank" href="tel:+32472012405"
            >+32472012405</a
          >
          <a class="button" target="_blank" href="mailto:kate@huureenstuur.be"
            >kate@huureenstuur.be</a
          >
          <span>Wiedauwkaai 98, 9000 Gent</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Wellbeing",
};
</script>
<style scoped>
.modal {
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
}
.modal__close {
  text-align: right;
  margin-bottom: 0.5rem;
}
.modal__backdrop {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.modal__wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  width: 360px;

  background: white;
  padding: 0.5rem;
  border-radius: 1rem;
}
.modal__data {
  display: grid;
  grid-gap: 1rem;
}
.person {
  text-align: center;
  display: grid;
  grid-gap: 0.5rem;
  padding: 1rem;
  background: #e5e5e5;
}
.person span:nth-child(2) {
    font-weight: bold;
    font-size: 1.2rem;
}
</style>
